import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { HttpService } from '../../../api/http.service';
import { IPhoneCode } from '../../models/phone-code.interface';
import { NotificationService } from '../../services/notification.service';

export class PhoneNumberControlComponent {
  public static $inject = [
    '$attrs',
    'http',
    'notificationService',
    'retailerServiceUrl',
    '$timeout',
    '$window',
    '$scope',
    '$element'
  ];
  public model: string;
  public phoneCodes: IPhoneCode[];
  public filteredPhoneCodes: IPhoneCode[];
  public searchTerm: string = '';
  public selectedCode: IPhoneCode;
  public searchOpened = false;
  public minNumberLength: number;
  public maxNumberLength: number;
  public width: number;
  public appendToBody = false;

  private countryPhoneCodeID: number;
  private ngModel: ng.INgModelController;
  private requiredBol: boolean;

  constructor(
    public $attrs: ng.IAttributes,
    private httpService: HttpService,
    private notificationService: NotificationService,
    private retailerServiceUrl: string,
    private $timeout: ng.ITimeoutService,
    private $window: ng.IWindowService,
    private $scope: ng.IScope,
    private $element: JQLite
  ) {
  }

  public async $onInit() {
    this.loadCodes();
    this.ngModel.$render = () => {
      this.model = this.ngModel.$viewValue ? this.ngModel.$viewValue : '';
    };
    this.requiredBol = !!(this.$attrs.$attr as any).required;
    this.watchModel();
  }

  public onChange() {
      if ((!this.model && this.requiredBol) || (this.model && this.model.toString().length < this.minNumberLength)) {
          this.ngModel.$setValidity('minNumberLength', false);
      } else {
          this.ngModel.$setValidity('minNumberLength', true);
      }
      if (this.model && this.model.toString().length > this.maxNumberLength) {
          this.ngModel.$setValidity('maxNumberLength', false);
      } else {
          this.ngModel.$setValidity('maxNumberLength', true);
      }
      if (this.selectedCode) {
          this.ngModel.$setViewValue(this.selectedCode.CountryCode.replace('-', '') + (this.model ? this.model : ''));
      }
  }

  public filterCodes() {
    if (this.searchTerm) {
      this.filteredPhoneCodes = this.phoneCodes.filter((code) => {
        const codeWithPlus = '+' + code.CountryCode;
        return codeWithPlus.includes(this.searchTerm) || code.CountryName.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    } else {
      this.filteredPhoneCodes = this.phoneCodes;
    }
  }

  public onCodeSelect(code: IPhoneCode) {
    this.selectedCode = code;
    this.countryPhoneCodeID = code.CountryOriginID;
    setTimeout(() => {
        this.onChange();
    }, 0);
    this.toggleSearch();
  }

  public clearSearchTerm() {
    this.searchTerm = '';
    this.filterCodes();
  }

  public onChangeSearchTerm() {
    this.filterCodes();
  }

  public toggleSearch() {
    if (!this.$attrs.disabled) {
      this.searchOpened = !this.searchOpened;
      if (this.searchOpened) {
        this.onFocus();
      } else {
        this.onBlur();
        this.clearSearchTerm();
      }
    }
  }

  public onFocus() {
    this.$element[0].classList.add('focus-border');
  }

  public onBlur() {
    this.$element[0].classList.remove('focus-border');
  }

    private watchCode() {
        this.$scope.$watch('ctrl.countryPhoneCodeID', (newVal: number, oldVal: number) => {
            if (newVal !== oldVal && newVal !== this.selectedCode.CountryOriginID) {
                this.selectedCode = this.phoneCodes.find((code) => code.CountryOriginID === this.countryPhoneCodeID);
                this.onChange();
            }
        });
    }

    private watchModel() {
        this.$scope.$watch('ctrl.model', () => {
            this.onChange();
        });
    }

  private async loadCodes() {
    this.phoneCodes = await this.httpService.get<IPhoneCode[]>(this.retailerServiceUrl + 'PhoneNumber/PhoneCodes');
    this.setDefaultCode();
    this.filterCodes();
    this.initScroll();
    this.initClickOutside();
  }

  private setDefaultCode() {
    if (!this.countryPhoneCodeID) {
      this.countryPhoneCodeID = 235;
    }
    this.selectedCode = this.phoneCodes.find((code) => code.CountryOriginID === this.countryPhoneCodeID);
    this.onChange();
    this.watchCode();
  }

  private initScroll() {
    this.$timeout(() => {
      ($('.codes-scroll') as any).mCustomScrollbar({
        axis: 'y',
        theme: 'minimal-dark'
      });
    });
  }

  private initClickOutside() {
    this.$timeout(() => {
      const menuElement = ($('.codes-menu') as any)[0];
      const codeRect = ($('.code-rect') as any)[0];
      angular.element(this.$window).on('click', (event) => {
        if (this.searchOpened && !codeRect.contains(event.target)) {
          if (menuElement.contains(event.target)) {
            return;
          }
          this.toggleSearch();
          this.$scope.$apply();
        }
      });
    });
  }
}

angular.module('app.common').component('phoneNumberControl', {
  template: require('./phone-number-control.component.html'),
  controller: PhoneNumberControlComponent,
  controllerAs: 'ctrl',
  require: {
    ngModel: '?ngModel'
  },
  bindings: {
    minNumberLength: '=',
    maxNumberLength: '=',
    width: '=',
    appendToBody: '=',
    model: '=',
    countryPhoneCodeID: '='
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/phone-number-control/phone-number-control.component.ts